// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, layoutContainer, xScreen } from "@adl/XDL/Utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface BannerPageLayoutSharedStyles {
    wrapper?: InjectableCss;
    bannerSection?: InjectableCss;
    bannerWrapper?: InjectableCss;
    infoSection?: InjectableCss;
    mainSection?: InjectableCss;
}

const bannerPageLayoutSharedStyles: BannerPageLayoutSharedStyles = {
    bannerSection: {
        css: css`
            margin-bottom: ${({ gap }: any) => `${gap || 8}px;`};
            ${({ backgroundImage }: any) =>
                backgroundImage &&
                css`
                    ${xScreen("gt", "sm")} {
                        background: ${color("common.white")};
                    }
                `};
            ${layoutContainer}
        `,
    },
    bannerWrapper: {
        css: css`
            position: relative;
            ${xScreen("gt", "sm")} {
                ${({ backgroundImage, isCmsEditing }: any) =>
                    css`
                        ${backgroundImage &&
                        css`
                            background-image: url(${backgroundImage});
                            background-repeat: no-repeat;
                            background-size: cover;
                        `}
                        ${!isCmsEditing &&
                        css`
                            height: 140px;
                        `}
                    `};
            }
        `,
    },
    infoSection: {
        css: css`
            height: 100%;
            padding-top: 20px;
            nav[data-test-selector="pageBreadcrumbs"] {
                margin-bottom: 20px;
            }

            ${xScreen("gt", "sm")} {
                background: linear-gradient(
                    0.25turn,
                    ${color("common.white")},
                    80%,
                    ${color("common.white", 0.8)},
                    95%,
                    ${color("common.white", 0)}
                );

                width: 100%;
                max-width: 46%;

                h2,
                h1 {
                    margin-bottom: 0;
                }
            }

            ${xScreen("lte", "md")} {
                max-width: 70%;
            }
        `,
    },
    mainSection: {
        css: css`
            width: 100%;
            ${layoutContainer}
        `,
    },
};

export default bannerPageLayoutSharedStyles;
